module.exports = __webpack_public_path__ + "images/101_1024.jpg";